import React from 'react'

import AccordionItem from 'shared/components/Accordion/AccordionItem'
import { MaterialType, Materials, ZipType } from './materials'
import { useWindowSize } from 'shared/hooks'

import classNames from 'classnames'
import classes from './PressMaterials.module.scss'

type Props = {
  materials?: MaterialType[]
  title?: string
  titleUppercase?: boolean
  isReveal?: boolean
}

export const PressMaterials = ({
  materials = Materials,
  title,
  titleUppercase,
  isReveal = true,
}: Props): JSX.Element => {
  const { isMobile } = useWindowSize()
  const titleClasses = classNames([classes.title], 'second-title', {
    uppercase: titleUppercase,
  })
  const divAttributes = isReveal
    ? {
        className: 'container reveal-from-bottom-medium',
        ['data-reveal-delay']: 50,
      }
    : {
        className: 'container',
      }

  const renderLink = (href: string, name: string, icon: string) => {
    return (
      <a href={href} download className={classes.zip}>
        <img src={icon} alt="icon" />
        {name}
      </a>
    )
  }

  const renderMaterialPreview = (
    preview?: string,
    previewMobile?: string,
    alt?: string
  ): JSX.Element | null => {
    if (!preview) {
      return null
    }

    const src = isMobile && previewMobile ? previewMobile : preview

    return <img src={src} className={classes.logo__img} alt={alt || 'icon'} />
  }

  const renderMaterialsWithPreview = (materials: ZipType[]) => {
    return (
      <div className={`${classes['zips-container']} row`}>
        {materials.map((zip, zipIndex) => {
          return (
            <div key={`zipBlock_${zipIndex}`} className={classes.logo}>
              {renderMaterialPreview(
                zip?.preview,
                zip?.previewMobile,
                zip?.previewAlt
              )}

              {renderLink(zip.href, zip.name, zip.fileIcon)}
            </div>
          )
        })}
      </div>
    )
  }

  const renderMaterials = (materials: ZipType[]) => {
    return materials.map((zip, zipIndex) => (
      <div key={zipIndex}>{renderLink(zip.href, zip.name, zip.fileIcon)}</div>
    ))
  }

  return (
    <div {...divAttributes} style={{ marginBottom: '100px' }}>
      {title && <h2 className={titleClasses}>{title}</h2>}

      {materials.map((material, index) => (
        <AccordionItem
          key={index}
          title={material.title}
          descr={material?.descr || ''}
        >
          {!material?.withPreview
            ? renderMaterials(material.zips)
            : renderMaterialsWithPreview(material.zips)}
        </AccordionItem>
      ))}
    </div>
  )
}
